import { CropRatio } from "./CropRatio/CropRatio";
import { Size } from "./Size/Size";
import { useBulkResizerCropSettings } from "./useBulkResizerCropSettings";
import { Left } from "./Left/Left";
import { Top } from "./Top/Top";
import { Translate } from "components/common/Translate/Translate";

interface BulkResizerCropSettingsProps {
    imageId: string;
}

export const BulkResizerCropSettings = ({ imageId }: BulkResizerCropSettingsProps) => {
    const {
        ratio,
        handleRatioChange,
        height,
        width,
        handleWidthChange,
        handleHeightChange,
        handleTopChange,
        handleLeftChange,
        customRatioX,
        customRatioY,
        handleCustomRatioXChange,
        handleCustomRatioYChange,
    } = useBulkResizerCropSettings(imageId);

    return (
        <div className="flex flex-col h-full max-h-full">
            <div className="flex-grow lg:gap-8 px-6 pt-6 pb-6">
                <div className="text-lg lg:text-2xl font-semibold pb-4">
                    <Translate keyName="crop-rectangle" />
                </div>
                <div className="pb-4">
                    <Size
                        width={width}
                        height={height}
                        handleWidthChange={handleWidthChange}
                        handleHeightChange={handleHeightChange}
                    />
                </div>
                <div className="flex flex-col flex-grow">
                    <CropRatio
                        ratio={ratio}
                        handleCropRatioChange={handleRatioChange}
                        customRatioX={customRatioX}
                        customRatioY={customRatioY}
                        handleCustomRatioXChange={handleCustomRatioXChange}
                        handleCustomRatioYChange={handleCustomRatioYChange}
                    />
                </div>

                <div className="mt-2 text-lg lg:text-2xl font-semibold py-6">
                    <Translate keyName="crop-position" />
                </div>

                <div className="flex gap-2">
                    <Left imageId={imageId} handleChange={handleLeftChange} />
                    <Top imageId={imageId} handleChange={handleTopChange} />
                </div>
            </div>
        </div>
    );
};
